import axiosInstance from "../utils/axios";

export const createQuestion = async (formData) => {
  const headers = {
    Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    "Content-Type": "multipart/form-data",
  };
  return axiosInstance.post('/api/questions', formData, { headers });
};

export const getQuestion = async (params) => {
  const headers = { Authorization: `Bearer ${localStorage.getItem("accessToken")}` };
  return axiosInstance.get('/api/questions', { headers, params });
};

export const getQuestionById = async (id) => {
  const headers = { Authorization: `Bearer ${localStorage.getItem("accessToken")}` };
  return axiosInstance.get(`/api/questions/${id}`, { headers });
};

export const updateQuestion = async (id, formData) => {
  const headers = {
    Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    "Content-Type": "multipart/form-data",
  };
  return axiosInstance.put(`/api/questions/${id}`, formData, { headers });
};

export const deleteQuestion = async (id) => {
  const headers = { Authorization: `Bearer ${localStorage.getItem("accessToken")}` };
  return axiosInstance.delete(`/api/questions/${id}`, { headers });
};

// For dropdowns
export const getTopics = async () => {
  const headers = { Authorization: `Bearer ${localStorage.getItem("accessToken")}` };
  return axiosInstance.get(`/api/get-all-topics`, { headers });
};

export const getSubTopics = async (topicId) => {
  const headers = { Authorization: `Bearer ${localStorage.getItem("accessToken")}` };
  return axiosInstance.get(`/api/subtopics`, { headers, params: { topic: topicId } });
};

export const fetchAllQuestions = async (page = 1, limit = 10) => {
  const headers = { Authorization: `Bearer ${localStorage.getItem("accessToken")}` };
  return axiosInstance.get('/api/questions', { headers, params: { page, limit } });
};
